import { useTranslation } from 'react-i18next';
import { S, Icon } from '../regureStyles';
import { productLabel } from '../../utils/productCatalog';

const STATUS_LABEL_KEYS = {
  all:       'screens.policiesScreen.allStatus',
  approved:  'screens.policiesScreen.statusApproved',
  rejected:  'screens.policiesScreen.statusRejected',
  // Raw statuses kept so a deep link carrying one still renders a label.
  active:    'screens.policiesScreen.statusActive',
  expired:   'screens.policiesScreen.statusExpired',
  cancelled: 'screens.policiesScreen.statusCancelled',
  pending:   'screens.policiesScreen.statusPending',
  bound:     'screens.policiesScreen.statusBound',
};

const Filter = ({
  search,
  setSearch,
  setPage,
  statusFilter,
  setStatusFilter,
  STATUS_OPTIONS,
  productFilter,
  setProductFilter,
  PRODUCT_OPTIONS,
  filtered,
}) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        padding: '14px 32px',
        display: 'flex',
        gap: 10,
        alignItems: 'center',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.6)',
        flexWrap: 'wrap',
      }}
    >
      <div style={{ position: 'relative', flex: 1, minWidth: 240, maxWidth: 380 }}>
        <div style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
          <Icon name='search' color='#94a3b8' size={15} />
        </div>
        <input
          value={search}
          onChange={e => {
            setSearch(e.target.value);
            setPage(1);
          }}
          placeholder={t('screens.policiesScreen.searchPlaceholder')}
          style={{
            width: '100%',
            padding: '9px 12px 9px 36px',
            background: '#fff',
            border: `1px solid ${S.borderLight}`,
            borderRadius: 8,
            fontSize: 13,
            color: S.textPrimary,
            outline: 'none',
            boxSizing: 'border-box',
          }}
        />
      </div>
      <select
        value={statusFilter}
        onChange={e => {
          setStatusFilter(e.target.value);
          setPage(1);
        }}
        style={{
          padding: '8px 12px',
          background: '#fff',
          border: `1px solid ${S.borderLight}`,
          borderRadius: 8,
          fontSize: 13,
          color: S.textSecondary,
          cursor: 'pointer',
          outline: 'none',
        }}
      >
        {STATUS_OPTIONS.map(o => (
          <option key={o} value={o}>
            {STATUS_LABEL_KEYS[o] ? t(STATUS_LABEL_KEYS[o]) : o}
          </option>
        ))}
      </select>
      <select
        value={productFilter}
        onChange={e => {
          setProductFilter(e.target.value);
          setPage(1);
        }}
        style={{
          padding: '8px 12px',
          background: '#fff',
          border: `1px solid ${S.borderLight}`,
          borderRadius: 8,
          fontSize: 13,
          color: S.textSecondary,
          cursor: 'pointer',
          outline: 'none',
        }}
      >
        {PRODUCT_OPTIONS.map(o => (
          // D-20 retest: without an explicit `value`, the browser used the
          // TRANSLATED label as the option value. Backend received
          // `lob=RC Pro` instead of `lob=RC_PRO` and matched nothing. The
          // status select above sets value={o} for the same reason.
          <option key={o} value={o}>
            {o === 'All Products' ? t('screens.policiesScreen.productAll') : productLabel(t, o, null, 'short')}
          </option>
        ))}
      </select>
      <span style={{ marginLeft: 'auto', fontSize: 12, color: S.textMuted }}>{t('screens.policiesScreen.resultsCount', { count: filtered.length })}</span>
    </div>
  );
};

export default Filter;
